import { BACKEND_ROOT, OAUTH_CLIENT_ID } from "./bundleConfiguration";

export * from "./bundleConfiguration";

export const API_ROOT = `${BACKEND_ROOT}/api`;

export const OAUTH = {
  CLIENT_ID: OAUTH_CLIENT_ID,
  SCOPES: ["read", "write"],
};

// Image Routes
export const IMAGE_ROUTES = {
  PRIMARY: "featured-image",
  SOCIAL: "social-image",
  BLOCK: "image",
};

// Breakpoints
export const BREAKPOINT_SMALL = "(min-width: 768px)";
export const BREAKPOINT_MEDIUM = "(min-width: 1024px)";
export const BREAKPOINT_LARGE = "(min-width: 1280px)";

// Statuses
export const STATUS = {
  UNASSIGNED: {
    className: "unassigned",
    label: "Unassigned",
    slug: "unassigned",
  },
  IN_PROGRESS: {
    className: "inProgress",
    label: "In progress",
    slug: "in-progress",
  },
  READY_FOR_EDITS: {
    className: "readyForEdits",
    label: "Ready for edits",
    slug: "ready-for-edits",
  },
  SCHEDULED: { className: "scheduled", label: "Scheduled", slug: "scheduled" },
  PUBLISHED: { className: "published", label: "Live", slug: "published" },
  DELETED: { className: "deleted", label: "Deleted", slug: "deleted" },
};

export function getStatusFromSlug(slug) {
  return Object.values(STATUS).find(status => status.slug === slug);
}

// Sort Options
export const SORT = {
  BY_ETA: { label: "Sort by ETA", value: "eta" },
  BY_LAST_UPDATED: { label: "Sort by last edited", value: "-last_updated" },
  BY_PUBLISHED_DATE: {
    label: "Sort by published time",
    value: "-published_date,-scheduled_date",
  },
};

export const MESSAGES = {
  info: "info",
  failure: "failure",
  success: "success",
};

// Timing
export const MESSAGE_VISIBILITY_DURATION = 5;

export const IMAGE_TYPES = [
  { mimetype: "image/jpeg", name: "JPEG" },
  { mimetype: "image/png", name: "PNG" },
  { mimetype: "image/gif", name: "GIF" },
];

// SECTIONS
export const SECTIONS = {
  TOP: {
    id: "00000000-0000-0000-0002-000000000007",
    name: "Top Stories",
  },
};

export const DATETIME_FORMAT = "MMM D [at] h:mma zz";

export const URL_REGEX = /^((https?:\/\/)\S+\.\S{1,}(\/.+)?\S|mailto:\S+@.+)$/;

export const UUID_REGEXP = /(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/;

export const ISO_REGEXP = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z)?)$/;

export const CSS_COLOR_REGEXP = /#[A-Fa-f0-9]{3,6}/;

export const LOCAL_NEWSLETTERS = [
  "axios-charlotte",
  "axios-tampa-bay",
  "axios-denver",
  "axios-des-moines",
  "axios-twin-cities",
  "axios-nw-arkansas",
];

export const CURATION_FILTERS = {
  DRAFT: { public: false },
  PUBLISHED: { public: true },
};
